module.exports = __webpack_public_path__ + "static/kraken-2929655acdfb04f5be20dc74c405a232.jpg";